import React, { useRef, useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import Crab from "../../../../Asset/icon/Crab.svg";
import BinocularsRight from "../../../../Asset/icon/binoculars-right.svg";
import BinocularsLeft from "../../../../Asset/icon/Binoculars-left.svg";
import CustomButtonGroupAsArrows from "../../../../components/carousel/CustomButtonGroupAsArrows";
import BestSellerCard from "../../../../components/card/BestSellerCard";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getBookingDetail } from "../../../../redux/booking/BookingSlice";
import { getYachtDetail } from "../../../../redux/yacht/YachtSlice";
import { getYachtInformationDetail } from "../../../../redux/yachtInformation/YachtInformationSlice";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import {
  getCountryDetail,
  getProvinceDetail,
  getMarinaDetail,
} from "../../../../redux/centerData/CenterDataSlice";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";

function BestSeller() {
  const CustomDot = ({ onClick, index, active }) => (
    <button
      style={{
        background: active ? "#00305c" : "grey",
        width: "10px",
        height: "10px",
        margin: "5px 5px",
        border: "none",
        borderRadius: "50%",
        cursor: "pointer",
      }}
      onClick={() => onClick()}
    ></button>
  );

  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 719);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 719);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { t } = useTranslation();
  const selectedLanguage = localStorage.getItem("selectedLanguage");
  const carouselRef1 = useRef(null);
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1600 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1600, min: 1200 },
      items: 3,
    },
    laptop: {
      breakpoint: { max: 1200, min: 992 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 992, min: 768 },
      items: 2,
    },
    smallTablet: {
      breakpoint: { max: 768, min: 600 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      partialVisibility: true,
    },
  };

  const [selectedProvince, setSelectedProvince] = useState("Phuket");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      dispatch(getProvinceDetail({})),
      dispatch(getCountryDetail({})),
      dispatch(getMarinaDetail({})),
      dispatch(getBookingDetail({})),
      dispatch(getYachtInformationDetail({})),
      dispatch(getYachtDetail({})),
      dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const filteredBookings = todos.Booking.Booking.results
    ? todos.Booking.Booking.results.filter(
      (Booking) =>
        Booking.status === "COMPLETED" || Booking.status === "BOOKED"
    )
    : [dispatch];

  const groupedBookings = {};
  filteredBookings.forEach((booking) => {
    const idYachtInfo = booking.id_yachtInfo;
    if (!groupedBookings[idYachtInfo]) {
      groupedBookings[idYachtInfo] = [];
    }
    groupedBookings[idYachtInfo].push(booking);
  });

  const yachtScores = Object.keys(groupedBookings).map((idYachtInfo) => ({
    idYachtInfo,
    score: groupedBookings[idYachtInfo].length,
  }));

  const top5Scores = yachtScores.sort((a, b) => b.score - a.score).slice(0, 20);

  const yachtList =
    todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList.results
      ?.filter((item) => item.rate_plan_use_in_TMY_web_site === 1)
      .filter((filteredItem) => {
        const matchingYachtInformation =
          todos.YachtInformationSlice?.YachtInformation?.results?.find(
            (yachtItem) => yachtItem.id_yachtInfo === filteredItem.id_yachtInfo
          );
        const matchingMarina = todos.CenterDataSlice?.Marina?.results?.find(
          (MarinaItem) =>
            MarinaItem.id_marina === matchingYachtInformation?.id_marina
        );

        const matchingProvince = todos.CenterDataSlice?.Province?.results?.find(
          (provinceItem) =>
            provinceItem.ProvinceID === matchingMarina?.id_province
        );
        return (
          matchingYachtInformation &&
          matchingMarina &&
          matchingProvince &&
          (!selectedProvince ||
            matchingProvince.ProvinceEng === selectedProvince)
        );
      }) || [];

  return (
    <div className="bodyTop-container">
      <div
        className="Header-Frame flex-wrap-col-space"
      >
        <div>
          <img
            className="BoatHelm-Tophotdeal"
            draggable={false}
            src={BoatHelm}
            alt="BoatHelm"
          />
        </div>

        <div className="hotdeal-ofday">
          <h2>
            <img
              className="BoatHelm-hotdeal"
              draggable={false}
              src={Crab}
              alt="BoatHelm"
            />
          </h2>
          <h2
            className="cursor-pointer"
            onClick={() => setSelectedProvince("")}
          >
            {t("bestSeller")}
          </h2>
          <h2>
            <img
              className="BoatHelm-hotdeal"
              draggable={false}
              src={Crab}
              alt="BoatHelm"
            />
          </h2>
        </div>

        <div className="hotdeal-ofday">
          <h2>
            <img
              draggable={false}
              className="BoatHelm-hotdeal"
              src={BinocularsRight}
              alt="BoatHelm"
            />
          </h2>

          <h2>
            {todos?.CenterDataSlice?.Marina?.results?.length > 0 ? (
              Array.from(
                new Set(
                  todos.CenterDataSlice.Marina.results.map((filteredItem) => {
                    const matchingProvince =
                      todos.CenterDataSlice.Province.results?.find(
                        (provinceItem) =>
                          provinceItem.ProvinceID === filteredItem.id_province
                      );

                    const provinceName = matchingProvince
                      ? selectedLanguage === "th"
                        ? matchingProvince.ProvinceThai
                        : matchingProvince.ProvinceEng
                      : null;

                    return JSON.stringify({
                      name: provinceName,
                      engName: matchingProvince?.ProvinceEng,
                    });
                  })
                )
              )
                .slice(0, 5)
                .map((provinceStr, index, array) => {
                  const { name, engName } = JSON.parse(provinceStr);
                  return (
                    <div
                      key={index}
                      className={`province-item ${selectedProvince === engName ? "selected" : ""
                        }`}
                      onClick={() => setSelectedProvince(engName)}
                    >
                      <span className="province-hot2"> {name} </span>
                      {index < array.length - 1}
                    </div>
                  );
                })
            ) : (
              <div>
                <CircularProgress className="text-primary-dark" />
              </div>
            )}
          </h2>

          <h2>
            <img
              draggable={false}
              className="BoatHelm-hotdeal"
              src={BinocularsLeft}
              alt="BoatHelm"
            />
          </h2>
        </div>
      </div>

      {loading ? null : (
        <div className="relative-center-full">
          <div
            className="carousel-container w-80-center"
          >
            {yachtList.length > 0 ? (
              <Carousel
                ref={carouselRef1}
                customButtonGroup={
                  window.innerWidth >= 719 ? (
                    <CustomButtonGroupAsArrows
                      carouselRefs={[carouselRef1]}
                      customPreviousStyle={{ left: "-10vh", zIndex: 999 }}
                      customNextStyle={{ right: "-10vh", zIndex: 999 }}
                    />
                  ) : null
                }
                renderButtonGroupOutside
                additionalTransfrom={0}
                arrows={false}
                centerMode={window.innerWidth >= 719 ? true : false}
                className=""
                containerClass="container"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderDotsOutside={false}
                responsive={responsive}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots={false}
                customDot={<CustomDot />}
                sliderClass=""
                slidesToSlide={1}
                swipeable
                autoPlay={true}
                autoPlaySpeed={4000}
              >
                {todos.YachtInfoSellingPriceRatePlanListSlice
                  .YachtInfoSellingPriceRatePlanList.results &&
                  todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList.results
                    .filter((item) => item.rate_plan_use_in_TMY_web_site === 1)
                    .map((filteredItem, index) => {
                      const matchingYachtInformation =
                        todos.YachtInformationSlice.YachtInformation.results.find(
                          (yachtItem) =>
                            yachtItem.id_yachtInfo === filteredItem.id_yachtInfo
                        );

                      const matchingMarina =
                        todos.CenterDataSlice.Marina.results.find(
                          (MarinaItem) =>
                            MarinaItem.id_marina ===
                            matchingYachtInformation.id_marina
                        );

                      const matchingProvince =
                        todos.CenterDataSlice.Province.results.find(
                          (provinceItem) =>
                            provinceItem.ProvinceID ===
                            matchingMarina.id_province
                        );

                      if (
                        matchingYachtInformation &&
                        matchingMarina &&
                        matchingProvince
                      ) {
                        const matchingScore = top5Scores.find(
                          (score) =>
                            score.idYachtInfo === filteredItem.id_yachtInfo
                        );

                        if (
                          !selectedProvince ||
                          (matchingProvince &&
                            matchingProvince.ProvinceEng === selectedProvince)
                        ) {
                          return (
                            <div
                              key={index}
                              className={` ${selectedProvince ===
                                matchingProvince.ProvinceEng
                                ? `${matchingProvince}`
                                : ""
                                } ${matchingScore ? "top5" : ""}`}
                            >
                              <Link
                                to={`/yacht/detailYacht/${filteredItem.id_sellingPrice}`}
                              >
                                <BestSellerCard
                                  image={
                                    matchingYachtInformation.logo_yachtInfo_url
                                  }
                                  headline={
                                    matchingYachtInformation.name_yacht_yachtInfo
                                  }
                                  location={
                                    selectedLanguage === "en"
                                      ? matchingMarina.name_marina_en
                                      : matchingMarina.name_marina_th
                                  }
                                  country={
                                    selectedLanguage === "en"
                                      ? matchingProvince.ProvinceEng
                                      : matchingProvince.ProvinceThai
                                  }
                                // score={
                                //   matchingScore ? matchingScore.score : null
                                // }
                                />
                              </Link>
                            </div>
                          );
                        }
                      }
                      return null;
                    })}
              </Carousel>
            ) : (
              <div
                className="flex-center-full"
              >
                <div
                  className="upload-dropzone"
                >
                  {/* Icon */}
                  <div className="text-2_5rem">⭐</div>

                  {/* Title */}
                  <div
                    className="text-lg-semibold"
                  >
                    {t("No Best Seller yachts yet")}
                  </div>

                  {/* Subtitle */}
                  <div
                    className="text-muted-desc"
                  >
                    {t(
                      "Best Seller yachts will appear here once enough bookings are made."
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default BestSeller;
